import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../lib/api';

const STATUSES = ['new', 'contacted', 'qualified', 'won', 'lost'];
const BLANK = { first_name: '', last_name: '', email: '', phone: '', company: '', source: '', value: '', notes: '', status: 'new' };
// @@DEMO_INVITE_v77@@
const BLANK_INVITE = { first_name: '', last_name: '', email: '', company: '' };

export default function Leads() {
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [form, setForm] = useState(BLANK);
  const [msg, setMsg] = useState('');
  const [showForm, setShowForm] = useState(false);
  // @@DEMO_INVITE_v77@@
  const [invite, setInvite] = useState(BLANK_INVITE);
  const [showInvite, setShowInvite] = useState(false);
  const [inviteMsg, setInviteMsg] = useState('');
  const [inviteBusy, setInviteBusy] = useState(false);

  async function load() {
    const res = await apiFetch('/api/leads');
    if (res.ok) { const d = await res.json(); setLeads(d.leads); }
  }
  useEffect(() => { load(); }, []);

  async function create() {
    setMsg('');
    const res = await apiFetch('/api/leads', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });
    if (res.ok) {
      setForm(BLANK); setShowForm(false); load();
    } else {
      const d = await res.json().catch(() => ({}));
      setMsg(d.error || 'Could not create lead.');
    }
  }

  // @@DEMO_INVITE_v77@@ send the demo portal login and file them as a lead.
  async function sendInvite() {
    setInviteMsg(''); setInviteBusy(true);
    try {
      const res = await apiFetch('/api/leads/demo-invite', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(invite),
      });
      const d = await res.json().catch(() => ({}));
      if (res.ok) {
        setInvite(BLANK_INVITE);
        setInviteMsg(d.created ? 'Invite sent — lead created.' : 'Invite sent — added to the existing lead.');
        load();
      } else {
        setInviteMsg(d.error || 'Could not send the invite.');
      }
    } catch (e) {
      setInviteMsg('Could not reach the server. Try again.');
    } finally {
      setInviteBusy(false);
    }
  }

  function fmtDate(s) {
    if (!s) return '—';
    try { return new Date(s).toLocaleDateString(); } catch { return '—'; }
  }

  return (
    <div className="hq-page-content">
      <div className="hq-page-head">
        <h1>Leads</h1>
        <p>Track prospects and email opens.</p>
      </div>

      <div className="hq-panel" style={{ marginBottom: 20 }}>
        <div className="hq-panel-head">
          <h2>{showForm ? 'New lead' : 'Add a lead'}</h2>
          <button className="hq-btn" onClick={() => setShowForm((s) => !s)}>
            {showForm ? 'Cancel' : 'New lead'}
          </button>
        </div>
        {showForm && (
          <div style={{ padding: 20 }}>
            <div className="hq-form">
              <input className="hq-input" placeholder="First name" value={form.first_name}
                onChange={(e) => setForm({ ...form, first_name: e.target.value })} />
              <input className="hq-input" placeholder="Last name" value={form.last_name}
                onChange={(e) => setForm({ ...form, last_name: e.target.value })} />
              <input className="hq-input" placeholder="Email" value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })} />
              <input className="hq-input" placeholder="Phone" value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })} />
              <input className="hq-input" placeholder="Company" value={form.company}
                onChange={(e) => setForm({ ...form, company: e.target.value })} />
              <input className="hq-input" placeholder="Source" value={form.source}
                onChange={(e) => setForm({ ...form, source: e.target.value })} />
              <input className="hq-input" placeholder="Value" value={form.value}
                onChange={(e) => setForm({ ...form, value: e.target.value })} />
              <select className="hq-select" value={form.status}
                onChange={(e) => setForm({ ...form, status: e.target.value })}>
                {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
              <button className="hq-btn" onClick={create}>Save</button>
            </div>
            {msg && <p className="hq-msg">{msg}</p>}
          </div>
        )}
      </div>

      {/* @@DEMO_INVITE_v77@@ */}
      <div className="hq-panel" style={{ marginBottom: 20 }}>
        <div className="hq-panel-head">
          <h2>Demo invite</h2>
          <button className="hq-btn" onClick={() => { setShowInvite((s) => !s); setInviteMsg(''); }}>
            {showInvite ? 'Cancel' : 'Send demo invite'}
          </button>
        </div>
        {showInvite && (
          <div style={{ padding: 20 }}>
            <div className="hq-form">
              <input className="hq-input" placeholder="First name" value={invite.first_name}
                onChange={(e) => setInvite({ ...invite, first_name: e.target.value })} />
              <input className="hq-input" placeholder="Last name" value={invite.last_name}
                onChange={(e) => setInvite({ ...invite, last_name: e.target.value })} />
              <input className="hq-input" placeholder="Email" value={invite.email}
                onChange={(e) => setInvite({ ...invite, email: e.target.value })} />
              <input className="hq-input" placeholder="Company (optional)" value={invite.company}
                onChange={(e) => setInvite({ ...invite, company: e.target.value })} />
              <button className="hq-btn" onClick={sendInvite} disabled={inviteBusy}>
                {inviteBusy ? 'Sending…' : 'Send invite'}
              </button>
            </div>
            <p className="hq-empty" style={{ padding: '12px 0 0' }}>
              Sends the demo portal login from your own address and files them as a lead.
              Opens are tracked, and an address already on file is reused rather than duplicated.
            </p>
            {inviteMsg && <p className="hq-msg">{inviteMsg}</p>}
          </div>
        )}
      </div>

      <div className="hq-panel">
        <div className="hq-panel-head"><h2>All leads</h2></div>
        <table className="hq-table">
          <thead>
            <tr><th>Name</th><th>Company</th><th>Status</th><th>Opens</th><th>Last open</th></tr>
          </thead>
          <tbody>
            {leads.map((l) => (
              <tr key={l.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/leads/${l.id}`)}>
                <td>{`${l.first_name} ${l.last_name}`.trim() || '—'}</td>
                <td>{l.company || '—'}</td>
                <td><span className={`hq-pill hq-status-${l.status}`}>{l.status}</span></td>
                <td>{l.open_count || 0}</td>
                <td>{fmtDate(l.last_opened_at)}</td>
              </tr>
            ))}
            {leads.length === 0 && (
              <tr><td className="hq-empty" colSpan={5}>No leads yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
